import React, { createRef, useEffect, useState, Component }                          from "react"
import { useParams }                                                                 from "react-router";
import shop                                                                          from "shop/shop"
import { Link, NavLink }                                                             from "react-router-dom";
import "../Budget/ModalForm.css"
import { loadState }                                                                 from "sdk/util/loadState";
import { Progress, Button, Container, Modal, Segment, Form, Dropdown, Input, Label, Tab, Message, Icon } from "semantic-ui-react";

const timeSpanNames = {
  0: "Warenkorb",
  1: "Tag",
  2: "Woche",
  3: "Monat",
  4: "Quartal",
  5: "Jahr"
}

//
// Kostenstellen bearbeitung
//
export default class CreateCostCentreModal extends Component {

  // tab register für stammdaten und benutzerzuordnung
  panes = [
    { menuItem: 'Daten', render: () =>
      (<Tab.Pane>
        <div className="ph4-ns ph3-m ph0">

          <Form.Field>
            <label>{translate( "Name" )}</label>
            <Input name={"name"} value={this.state.costcentre.name} onChange={ (e) => { this.setForm(e.currentTarget.name,e.currentTarget.value,false) }} required/>
          </Form.Field>

          <Form.Field>
            <label>{translate( "Kostenstelle" )}</label>
            <Input name={"costid"} value={this.state.costcentre.costid} onChange={ (e) => { this.setForm(e.currentTarget.name,e.currentTarget.value,false) }} required/>
          </Form.Field>

          <Form.Field>
            <label>{translate( "E-Mail" )}</label>
            <Input name={"email"} value={this.state.extras.email} onChange={ (e) => { this.setForm(e.currentTarget.name, e.currentTarget.value,true) }} required/>
          </Form.Field>

          <Form.Field>
            <label>{translate( "Anschrift" )}</label>
            <Input name={"street"} value={this.state.extras.street} onChange={ (e) => { this.setForm(e.currentTarget.name, e.currentTarget.value,true) }} required/>
          </Form.Field>

          <Form.Field>
            <label>{translate( "Zusatz" )}</label>
            <Input name={"info"} value={this.state.extras.info} onChange={ (e) => { this.setForm(e.currentTarget.name, e.currentTarget.value,true) }} />
          </Form.Field>

          <Form.Field>
            <label>{translate( "PLZ" )}</label>
            <Input name={"pcode"} value={this.state.extras.pcode} onChange={ (e) => { this.setForm(e.currentTarget.name, e.currentTarget.value,true) }} required/>
          </Form.Field>

          <Form.Field>
            <label>{translate( "Stadt" )}</label>
            <Input name={"city"} value={this.state.extras.city} onChange={ (e) => { this.setForm(e.currentTarget.name, e.currentTarget.value,true) }} required/>
          </Form.Field>
        </div>
      </Tab.Pane>) },
    { menuItem: 'Benutzer', render: () =>
      (<Tab.Pane>
        <Segment>
          <Dropdown
            placeholder="Benutzer auswählen"
            selection
            options={this.state.userlist}
            value={this.state.selectedUser}
            onChange={(e,{value}) => {this.setState({selectedUser: value})}}
          />
          <Button secondary onClick={(e) => { console.log(e); e.preventDefault(); this.addCCUser(); }}>+</Button>
        </Segment>
        {this.state.relations.map((r) => {
          return (
            <Segment clearing key={r.map_id}>
              <span>{this.state.usermap['u' + r.shopUser]} - ({r.shopUser})</span><Button floated="right" onClick={(e) => { e.preventDefault(); this.deleteRelation(r.map_id); }}><Icon name="trash"/></Button>
            </Segment>)
        })}
      </Tab.Pane>) },
  ]

  // default constructor
  constructor(props) {
    super(props)

    // bind local methods
    this.loadUserList  = this.loadUserList.bind(this);
    this.loadRelations = this.loadRelations.bind(this);
    this.addCCUser     = this.addCCUser.bind(this);

    // map special fields and check for new costcentre
    var extras = {}
    if (props.costcentre) {
      if (props.costcentre.extras) {
        Object.keys(props.costcentre.extras).forEach((k,v) => {
          extras[k] = props.costcentre.extras[k].value;
        });
      } else {
        props.costcentre.extras = {}; // avoid undefined access
      }
    } else {
      props.costcentre = { rules:[], extras:{}};
    }

    // set init state
    this.state = { ...props,relations:[], budy: false,extras: extras,alert: false }

    // start user loading
    if (shop.session.hasRole('usermanager')) {
      this.loadUserList();
    }

    console.log('VIEW CC STATE',this.state.costcentre);

  }

  deleteRelation(mapid) {
    var self = this;
    shop.fetch("/shop/rest/costcentre/relations?mapid=" + encodeURIComponent(mapid),{
      method: 'DELETE'
    }).then(() => {
      var update = self.state.relations.filter((e) => {
        return e.map_id != mapid;
      })
      console.log(update);
      self.setState({"relations":update})
      shop.toast('Gelöscht');
    })
  }

  // add a new user to the relations list
  addCCUser() {
    if (!this.state.costcentre || !this.state.costcentre.map_id) {
      shop.toast( 'Bitte zuerst die Kostenstelle speichern.' )
      return;
    }
    var self   = this;
    var newRel = { map_id: '', source: 'bshop', costcentre: this.state.costcentre.map_id, shopUser: String(this.state.selectedUser) };
    shop.fetch("/shop/rest/costcentre/relations",{
      method: 'POST',
      body: JSON.stringify(newRel),
    }).then(() => {
      shop.toast('Gespeichert');
      self.loadRelations();
    })
    console.log(newRel);
  }

  // load relations for the active costcentre
  async loadRelations() {
    console.log('load relations');
    var self = this;
    shop.fetch("/shop/rest/costcentre/relations?mapid=" + encodeURIComponent(this.state.costcentre.map_id),{}).then((data) => {
      console.log('check relations',data);
      self.setState({relations: data});
    });
  }

  // load users to connecto to costcentre for usermanager
  async loadUserList() {
    console.log('load user list');
    var self = this;
    shop.fetch("/shop/rest/users/data?start=0&count=100&filter=%7B%22customer_id%22%3A%22" + shop.session.value.map_id + "%22%7D",{}).then((data) => {
      var options = data.map((e) => {
        return {"key":e.id,"value":e.id,"text":e.name};
      });
      var usermap = {};
      data.forEach((u) => {
        usermap['u' + u.id] = u.name;
      })
      console.log('usermap',usermap);
      self.setState({"userlist":options,"usermap":usermap});
      self.loadRelations();
    })
  }

  setForm( k, v , ef) {
    if (ef) {
      var eupdate = this.state.extras || {};
      eupdate[k] = v;
      this.setState({"extras": eupdate});
    } else {
      var update = this.state.costcentre;
      update[k] = v;
      this.setState({"costcentre":update});
    }
  }

  async saveCostcentre() {
    this.state.busy = true;

    this.state.costcentre.extras = {};
    Object.keys(this.state.extras).forEach((k,v) => {
      this.state.costcentre.extras[k] = {"name":k,"value":this.state.extras[k]} ;
    })

    // check customer on new entries
    var newcc = false;
    if (!this.state.costcentre.customer) {
      newcc = true;
      this.state.costcentre.customer = shop.session.value.map_id;
      this.state.costcentre.source = 'bshop';
    }

    try {
      await shop.fetch( "/shop/rest/costcentre/data?ownerRelation=1", {
        method: "POST",
        body: JSON.stringify( this.state.costcentre )
      } ).then( (data) => {
        shop.toast(translate("Gespeichert"))
        if (newcc) {
          console.log(data);
          shop.session.costCentres.push(JSON.parse(JSON.stringify(data)));
        }
      })
    }
    catch (err) {
      console.log( err )
      shop.toast( err )
    }
    finally {
      this.state.busy = false;
    }
  }

  render() {
    return <Modal as={Form} onSubmit={() => {
      console.log('submit cost centre')
      this.saveCostcentre();
    }}
                  size={"small"} open={open}>
      <Modal.Header>
        <div className="ph4-ns ph3-m ph0">
          <div className="b f2-ns f3 pt2 pb2">{ this.state.costcentre.name || translate( "Neue Kostenstelle" )}</div>
          <div className="f5 black-60">{translate( "Kostenstelle erstellen" )}</div>
        </div>
      </Modal.Header>
      <Modal.Content>
        <Tab panes={this.panes}/>
        {this.state.alert && <Message warning header={this.state.alert}/>}
        { this.state.costcentre.rules.map((r,index) => {
          var percent = r.snapshot ? ((r.snapshot / r.maxValue) * 100) : 0;
          var attrs   = {};
          if (percent > 70) {
            attrs.warning = true;
          } else if (percent >= 100) {
            attrs.error = true;
          } else attrs.success = true;
          return (<Progress percent={percent} key={index} {...attrs}>
            { r.name + ' (' + timeSpanNames[r.timeSpan] + '): ' + Number(r.snapshot).toFixed(2) + ' / ' + Number(r.maxValue).toFixed(2) }
          </Progress>)
        }) }
      </Modal.Content>
      <Modal.Actions>
        <div className="ph4-ns ph3-m ph0 pb3 pt3">
          <div>
          <Button as={Link} to={this.props.backLink}>{translate( "Zurück" )}</Button>
            <Button loading={this.state.busy} type="submit" primary>{translate( "Speichern" )}</Button>
          </div>
        </div>
      </Modal.Actions>
    </Modal>
  }

}



// WEBPACK FOOTER //
// ./src/components/CostCentres/CostCentresEditForm.js